import React from "react"
import { gql } from "@apollo/client"
import GeneralGrid from "components/Templates/GeneralGrid"
import dayjs from "dayjs"

const myQuery = gql`
  query InwardQuery($first: Int, $skip: Int, $query: String) {
    allInwards(query: $query, first: $first, skip: $skip) {
      id
      weigh {
        id
        createdAt
        netWeight
      }
      purchaseOrder {
        id
        quantity
        unitPrice
        po {
          id
          code
        }
      }
      booking {
        id
        trip {
          id
          departmentAssigned {
            id
            name
          }
        }
        schedule {
          id
          date
          gatePass
          variety {
            id
            primaryGroup {
              id
              name
              codename
            }
          }
          scheduledIn {
            id
            name
          }
          plotCommodity {
            id
            name
          }
          plot {
            id
            farmer {
              id
              fullName
              companyCode
            }
          }
        }
      }
    }
  }
`

const Inwards = () => {
  const columns = [
    {
      Header: "GRN Date",
      accessor: "weigh.createdAt",
      width: 100,
      Cell: ({ value, original }) => dayjs(value).format("DD/MM/YYYY"),
    },
    {
      Header: "PO Date",
      accessor: "booking.schedule.date",
      width: 100,
      Cell: ({ value, original }) => dayjs(value).format("DD/MM/YYYY"),
    },
    {
      Header: "Gate Pass",
      accessor: "booking.schedule.gatePass",
      width: 100,
    },
    {
      Header: "Farmer Code",
      accessor: "booking.schedule.plot.farmer.companyCode",
      width: 100,
    },
    {
      Header: "Plot Name",
      accessor: "booking.schedule.plotCommodity.name",
      width: 210,
    },
    {
      Header: "PO Number",
      accessor: "purchaseOrder.po.code",
      width: 100,
    },
    {
      Header: "PO Qty.",
      accessor: "purchaseOrder.quantity",
      width: 80,
    },
    {
      Header: "PO Price",
      accessor: "purchaseOrder.unitPrice",
      width: 75,
    },
    {
      Header: "Variety Group",
      accessor: "booking.schedule.variety.primaryGroup.name",
      width: 140,
    },
    {
      Header: "Inward Wt.",
      accessor: "weigh.netWeight",
      width: 80,
    },
    {
      Header: "Dept (Schedule)",
      accessor: "booking.schedule.scheduledIn.name",
      width: 125,
    },
    {
      Header: "Dept (Trip)",
      accessor: "booking.trip.departmentAssigned.name",
      width: 125,
    },
  ]

  return (
    <GeneralGrid
      icon="box"
      title="Inwards"
      query={myQuery}
      columns={columns}
      itemLimit={20}
    />
  )
}

export default Inwards
